import { render, staticRenderFns } from "./CircularMenu.vue?vue&type=template&id=1ea43c80"
import script from "./CircularMenu.vue?vue&type=script&lang=js"
export * from "./CircularMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports